var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesAttachmentTracking = function SvgYeswareSalesAttachmentTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357,
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.422 22.582a14.203 14.203 0 0 0-20.089 0L19.158 43.755a10.464 10.464 0 0 0 14.797 14.797l17.198-17.203a6.72 6.72 0 1 0-9.496-9.494L31.07 42.433a2.042 2.042 0 0 0 2.885 2.889L44.542 34.73a2.64 2.64 0 0 1 3.732 3.734L31.07 55.667a6.382 6.382 0 1 1-9.027-9.027l21.175-21.173a10.125 10.125 0 1 1 14.32 14.32l-15.88 15.88a2.042 2.042 0 0 0-.026 2.91 2.04 2.04 0 0 0 2.91-.025l15.88-15.883a14.2 14.2 0 0 0 0-20.09v.003Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareSalesAttachmentTracking;